export const MAIN_ROUTE = "tivodevices";

export const PATHS = {
  applicationsClientType: `/${MAIN_ROUTE}/applications/:platformId/:oemId/:clientTypeId`,
  applicationsOem: `/${MAIN_ROUTE}/applications/:platformId/:oemId`,
  createClientType: `/${MAIN_ROUTE}/create/:platformId/:oemId`,
  createOem: `/${MAIN_ROUTE}/create/:platformId`,
  detailsClientType: `/${MAIN_ROUTE}/details/:platformId/:oemId/:clientTypeId`,
  detailsOem: `/${MAIN_ROUTE}/details/:platformId/:oemId`,
  editClientType: `/${MAIN_ROUTE}/edit/:platformId/:oemId/:clientTypeId`,
  editOem: `/${MAIN_ROUTE}/edit/:platformId/:oemId`,
};
